
export const DEFAULT_ID_NAME = 'id'
export const DEFAULT_PER_PAGE = 10
export const DEFAULT_LOCALE = 'ru'
export const DEFAULT_PER_PAGE_OPTIONS = [10, 25, 50, 100]
export const DEFAULT_TEXT_FILED_MAX_LENGTH = 300
export const DEFAULT_TEXTAREA_MAX_LENGTH = 1500
export const DEBOUNCE_TIMEOUT = 400
export const FILE_TAG_PUBLICATION = 'Публикация'
export const FILE_TAG_IMAGE = 'image'
export const FILE_TAG_LINK = 'link'

export const EXCEL_CELL_ERROR_LABEL = '#ССЫЛКА!'
export const FORM_TEMPLATE_CELL_ERROR_LABEL = '---'

/** @return {[number, number]} */
const getArray = (values, defaultValues) => {
  try {
    return JSON.parse(values)
  } catch {
    return defaultValues
  }
}

export const WS_RECONNECT_RETRY_COUNT = +process.env.VUE_APP_WS_RECONNECT_RETRY_COUNT || 3
export const WS_RECONNECT_RETRY_TIMEOUTS = getArray(process.env.VUE_APP_WS_RECONNECT_RETRY_TIMEOUTS, [1000, 3000])
export const WS_RECONNECT_TIMEOUTS = getArray(process.env.VUE_APP_WS_RECONNECT_TIMEOUTS, [5000, 10000])
